import { render, staticRenderFns } from "./FormSkeleton.vue?vue&type=template&id=48a62db2&"
import script from "./FormSkeleton.vue?vue&type=script&lang=js&"
export * from "./FormSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports